import React, { useContext, useCallback, MouseEvent } from 'react'

import RenderContext from './RenderContext'

import {
  ILayout_Render,
  ILayout_Cell_Props_Video,
} from '../types/layout'

import YoutubeEmbed from '../frontend/components/widgets/YoutubeEmbed'

/*

  RENDER

*/
const VideoComponent: ILayout_Render<ILayout_Cell_Props_Video> = ({
  cell,
  editMode,
}) => {
  const {
    url,
  } = cell.data
  const {
    disableLinks,
  } = useContext(RenderContext)
  const onClick = useCallback((e: MouseEvent) => {
    if (!disableLinks) return
    e.preventDefault()
    e.stopPropagation()
  }, [
    disableLinks,
  ])
  if (!url) return null
  const video = (
    <YoutubeEmbed
      id={url}
    />
  )

  // don't let them click on the video in edit mode (so they can drag the cell around)
  return editMode ? (
    <>
      { video }
      <div onClick={ onClick } style={{
        position: 'absolute',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%',
        zIndex: 1000,
      }}>
  
      </div>
    </>
  ) : video
}

export default VideoComponent